/**
 * Diretiva que serve para fechar pop up / cards que contem a diretiva  v-closebale
 * @param handler Nome do método que irá ser executado quando houver um click fora do componente
 * @param exclude Nome por ref dos componentes que não deverão realizar este método quando forem clicados
 */

let handleOutsideClick
export default {
	inserted(el, binding, vnode) {
		handleOutsideClick = (e) => {
			e.stopPropagation()
			const { handler, exclude } = binding.value
			let clickedOnExcludedEl = false
			exclude.forEach((refName) => {
				if (!clickedOnExcludedEl) {
					const excludedEl = vnode.context.$refs[refName]
					if (excludedEl) {
						clickedOnExcludedEl = excludedEl.contains(e.target)
					}
				}
			})
			if (!el.contains(e.target) && !clickedOnExcludedEl) {
				vnode.context[handler]()
			}
		}
		window.addEventListener('click', handleOutsideClick)
	},
	unbind() {
		window.removeEventListener('click', handleOutsideClick)
	},
}
